module.exports = __webpack_public_path__ + "img/poi-active.621d0592.svg";